import styles from './SupportTicketCardSkeleton.module.css';

export const SupportTicketCardSkeleton = () => (
	<div className={styles.card}>
		<div className={styles.top}>
			<div className={styles.topInfo}>
				<div className={`${styles.shimmer} ${styles.avatar}`} />
				<div className={styles.subjectGroup}>
					<div className={`${styles.shimmer} ${styles.subject}`} />
					<div className={`${styles.shimmer} ${styles.timeAgo}`} />
				</div>
			</div>
			<div className={styles.topActions}>
				<div className={`${styles.shimmer} ${styles.userName}`} />
				<div className={styles.actions}>
					<div className={`${styles.shimmer} ${styles.btn}`} />
					<div className={`${styles.shimmer} ${styles.btn}`} />
				</div>
			</div>
		</div>
		<div className={styles.bottom}>
			<div className={`${styles.shimmer} ${styles.dot}`} />
			<div className={`${styles.shimmer} ${styles.preview}`} />
		</div>
	</div>
);
